import React from "react";

const HeroSection = ({
  bgImage = "/propsourcing-platform-screenshot.png",
  videoThumb = "/video-thumb.jpg",
  onVideoClick, // optional handler
}) => {
  return (
    <section className="relative h-screen overflow-hidden flex items-center justify-center text-center">
      {/* Blurred background */}
      <img
        src={bgImage}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover scale-110 blur-sm md:blur"
      />
      {/* Dark gradient overlay for readability */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(0,0,0,0.55),rgba(0,0,0,0.75))]" />

      {/* Content */}
      <div className="relative z-10 w-full px-6">
        <div className="max-w-5xl mx-auto">
          {/* Eyebrow */}
          <p className="uppercase tracking-[0.2em] text-sm md:text-base text-white/70 mb-4">
            Attention: Property Investors
          </p>

          {/* Headline */}
          <h1 className="text-white font-extrabold leading-tight drop-shadow-xl text-4xl md:text-6xl lg:text-7xl mb-4">
            Source Investment Grade Off-Market Deals Faster
          </h1>

          {/* Subheadline */}
          <p className="text-white/85 text-base md:text-xl max-w-3xl mx-auto mb-8">
            How Australian investors are <span className="font-semibold text-white">leveraging offmarket platform</span> and
            <span className="font-semibold text-white"> getting offmarket deals</span> with Propsourcing™.
          </p>

          {/* Video CTA block */}
          <div className="max-w-3xl mx-auto">
            <div
              role="button"
              tabIndex={0}
              onClick={onVideoClick}
              onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onVideoClick?.()}
              className="group rounded-2xl overflow-hidden shadow-2xl border border-white/10 bg-black/20 backdrop-blur-sm cursor-pointer"
            >
              {/* Green strip CTA */}
              <div className="bg-[#22c55e] text-white text-xs md:text-sm font-semibold tracking-wide py-2">
                🔊 CLICK BELOW TO WATCH FIRST!
              </div>

              {/* Video thumbnail with play button */}
              <div className="relative">
                <img
                  src={videoThumb}
                  alt="Watch how Propsourcing™ works"
                  className="w-full h-auto object-cover aspect-video"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="grid place-items-center rounded-full w-16 h-16 md:w-20 md:h-20 bg-white/90 group-hover:bg-white transition">
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                      <path d="M8 5v14l11-7-11-7z" fill="#111827" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            {/* Optional helper text under video */}
            <p className="text-white/70 text-xs md:text-sm mt-3">
              2-minute overview • No email required
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
